import { Injectable } from '@angular/core';

import { CallApiMethodsService } from '../AsynchronousRequestServices/call-api-methods.service';
import { GetCurrentThemeService } from './get-current-theme.service';

import { AlphanumericValues, StringValues } from 'src/app/interfaces/undetermined';
import { Field } from 'src/app/interfaces/datatable';

@Injectable({ providedIn: 'root' })
export class SharedAsyncMethodsService {

  constructor(
    private callApiMethods: CallApiMethodsService,
    private currentTheme: GetCurrentThemeService,
  ) { }

  /* setDownloadParams(): Método que genera los parámetros para generar el archivo
    type: Extensión del archivo
    params: Operación a ejecutar en el servicio
    headers: Cabeceras de la tabla por libro
    body: Cuerpo de la tabla por libro
    sheets: Nombre de cada libro
    download: Nombre del archivo
    footers: Pie de página de la tabla por libro
  */
  setDownloadParams(type: string, params: StringValues, headers: (Field[][]) | string[] | string, body: (Field[][]) | string[] | string, sheets: string[] | string, download: string, footers: (Field[][]) | string = [[]], table: object | string = {}): Promise<Blob> {
    // styles: Tema selecionado
    const styles: string = JSON.stringify({ ...this.currentTheme.themeValues, group: this.currentTheme.themeGroups });
    // ↓ Convierte los parámetros array en cadena
    [headers, body, sheets, footers, table] = [JSON.stringify(headers), JSON.stringify(body), JSON.stringify(sheets), JSON.stringify(footers), JSON.stringify(table)];
    // parm: Parámetros a enviar al servicio
    const parm = { table, body, headers, footers, sheets, styles, rules: JSON.stringify({ headers: { classes: 'using-theme' } }), ...params };
    // ↓ Descarga el archivo
    return this.downloadFile(parm, `${download}.${type}`);
  }

  /* downloadFile(): Método que ejecuta la descarga del archivo generado desde el API
    params: Parámetros para enviar al API
    fileName: Nombre del archivo a descargar
  */
  downloadFile(params: AlphanumericValues, fileName: string): Promise<Blob> {
    // ↓ Promesa para ejecutar acciones después de finalizada la descarga
    return new Promise((resolve: (file: Blob) => void) => {
      // ↓ Envía la información al API para que este construya el archivo
      this.callApiMethods.sendAsynchronousRequest("management", "buildReports", params).then((file: Blob) => {
        // currentDate: Fecha y hora actuales
        const currentDate = new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toJSON().slice(0, 19).replace(/[-:]/g, '').replace(/[T]/g, '_');
        // link: Elemento HTML para la descarga
        const link: HTMLAnchorElement = document.createElement('a');
        // ↓ Agrega la url del archivo al link
        link.href = window.URL.createObjectURL(file);
        // ↓ Asigna el nombre del archivo
        link.download = `${currentDate}${fileName}`;
        // ↓ Ejecuta la descarga
        document.body.appendChild(link); link.click(); link.remove();
        // ↓ Comparte la promesa
        resolve(file);
      }).catch(this.callApiMethods.setError);
    });
  }

}
